import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { OriginalHeader } from "./headerTypes";
import { MailReferralHeader } from "./headerTypes/standardMailReferral";

function Header() {
  const [headerType, setHeaderType] = useState<String>("");
  const { token } = useParams();

  useEffect(() => {
    assignHeaderType();
  }, []);

  function assignHeaderType() {
    const pcs = window.location.href.split("/");
    setHeaderType(pcs[pcs.length - 1]);
  }

  function selectHeader() {
    return <MailReferralHeader />;
    // switch (headerType) {
    //     case "claim":
    //         return <OriginalHeader />;
    //         break;
    //     case "register":
    //         return <MailReferralHeader />;
    //         break;
    //     default:
    //         return <OriginalHeader />;
    //         break;
    // }
  }
  return selectHeader();
}

export default Header;
